import * as React from "react";
import cx from "classnames";

import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Tree, Classes, Intent } from "@blueprintjs/core";
import { Button, Card, Elevation,Icon, Overlay,H4 } from "@blueprintjs/core";
import{HomeProps} from './Home.tsx'
import  {MSG_VISIO} from "../MessagesVisio.js"
//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';
import {
  Alignment,
  H5,
  Navbar,
  Toast,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Toaster,
  Position,
  Code,
    MultistepDialog,
    DialogStep,
    ButtonProps,
    RadioGroup,
    Radio,
    NumericInput,
    Label,
} from "@blueprintjs/core";
import PanelNom from './PanelNom.tsx';
import PanelEmail from './PanelEmail.tsx';
import PanelPassword from './PanelPassword.tsx';
import PanelOnePassword from './PanelOnePassword.tsx';
import MyToaster from './components/MyToaster.tsx';
import { type, userInfo } from "os";
import { throws } from "assert";

export type type_home = {
value:undefined,
isValidSignin:undefined,
isValidLogin:undefined
}

export default class CardEnseignantCnx extends React.Component  <{}> {
 // class_selected=Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_SUCCESS;
 // class_noselected=Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_WARNING;
  msg_visio=MSG_VISIO;
  state = {
    name: '',
    dcnx:false,
    selected_mesdocuments:false,
    selected_visio:false,
    selected_reduire:640
  }  
  
  

  constructor(props) {
        super(props);
        
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
    console.log(this.props);
    //this.handleU();
   
    
  }
 
  componentDidUpdate(prevProps, prevState) {
    if(this.props.selected_visio!=this.state.selected_visio)this.setState({selected_visio:this.props.selected_visio})
   /* if (prevState.name !== prevProps.usernickname.nickname) {
      this.handleUpdateName();
    }*/
  }
 /* handleUpdateName = () => {
    this.setState({ name: this.props.usernickname.nickname });
    const item=document.getElementById('id_name');
    item.value=this.props.usernickname.nickname;
  }*/
   render() {
    
    const {nom_enseignant,handleOpenVisio,handleSelectPage}=this.props;
    const targetClassName_document = cx({'bp3-outlined':! this.state.selected_mesdocuments}, Classes.LARGE,  {'bp3-intent-success': this.state.selected_mesdocuments} );
    const targetClassName_visio = cx({'bp3-outlined':! this.state.selected_visio}, Classes.LARGE,  {'bp3-intent-success': this.state.selected_visio} );
    const targetClassName_dcnx = cx(Classes.OUTLINED, Classes.LARGE,  {'bp3-intent-danger': true} );
    const targetClassName_reduire = cx(Classes.OUTLINED, Classes.LARGE,  {'bp3-intent-danger': false} );
    return(
     <div style={{paddingTop:'50px',position:'relative',zIndex:10,width:'470px'}}>
     {nom_enseignant!=""? <Card style={{width:this.state.selected_reduire,margin:4,backgroundColor:'#e4eff7',padding: '10px'} } interactive={true} elevation={Elevation.TWO}>
     <Icon onClick={(ev)=>{ev.preventDefault();if(this.state.selected_reduire>60)this.setState({selected_reduire:40});else this.setState({selected_reduire:640});}} icon="info-sign" intent={Intent.PRIMARY} size={20}></Icon>
     {this.state.selected_reduire >60 ?<span><a onClick={(ev)=>{ev.preventDefault();this.setState({dcnx:true});}} style={{marginLeft:8}}>Vous êtes dans la classe de l'enseignant {nom_enseignant}</a>
     <Button style={{marginLeft:10}} onClick={(ev)=>{ev.preventDefault();this.setState({dcnx:true});}} className={targetClassName_dcnx} icon="delete" title="Se déconnecter de l'enseignant"></Button>
     <Button  onClick={(ev)=>{ev.preventDefault();if(!this.state.selected_visio){handleOpenVisio(this.msg_visio.OUVRIR_VISIO,"");this.setState({selected_visio:true});}else{handleOpenVisio(this.msg_visio.FERMER_VISIO,"");this.setState({selected_visio:false});}}}className={targetClassName_visio} icon="eye-open" title="Entrez dans la classe"></Button>
     <Button  onClick={(ev)=>{ev.preventDefault();if(!this.state.selected_mesdocuments){handleSelectPage("mesdocuments",1);this.setState({selected_mesdocuments:true});}else{handleSelectPage("mesdocuments",-1);this.setState({selected_mesdocuments:false});}}} className={targetClassName_document } icon="manual" title="Voir les document de l'enseignant"></Button>
     <Button  onClick={(ev)=>{ev.preventDefault();if(this.state.selected_reduire==640){this.setState({selected_reduire:40});}}} className={targetClassName_reduire } icon="arrow-left" title="Réduire"></Button>
      </span>:<div></div>}
     </Card>:<div></div>}
     <Overlay isOpen={this.state.dcnx} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
      
      <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
      
        <H4>Déconnexion</H4>
        <p>Vous voulez vous déconnecter de l'enseignant {nom_enseignant} ?</p>
          <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({dcnx:false});}}>Annuler</Button>
          <Button style={{marginLeft:5}} intent={Intent.SUCCESS} onClick={(ev)=>{ev.preventDefault();this.props.handlesetTeacherid_select(-1);this.setState({dcnx:false});}}>Déconnecter</Button>
        
      </div>
      </Overlay>
     </div>);
}
}
